import { Button } from "../../../../Common/AbstractComponents/Button";
import noUiSlider from 'nouislider';
import Vocabulary from "../../../../Common/Vocabulary";
import { Util } from "../../../../Common/Util";
import DeclensionNouns from "../../../../Common/DeclensionNouns";

export class Filters {
    constructor({ page, updateRoutes, getRoutes }) {
        this.$page = page;

        this._updateRoutes = updateRoutes;
        this._getRoutes = getRoutes;

        this.$filtersSidebar = $(this.$page).find('.avia_results_sidebar .avia_fiters');
        this.$filterBtn = this.$filtersSidebar.find('button.filter_btn');
        this.$resetBtn = this.$filtersSidebar.find('button.reset_btn');

        this.$priceSlider = document.getElementById('slider-price');
        this.$departureTimeSlider = document.getElementById('slider-time-1');
        this.$arrivalTimeSlider = document.getElementById('slider-time-2');
        this.$travelTimeSlider = document.getElementById('slider-time-3');

        this._numberOfFlights = 0;

        this._button = new Button({
            button: this.$filterBtn,
            onClick: this._filter.bind(this),
        });

        this._resetButton = new Button({
            button: this.$resetBtn,
            onClick: this._resetFilters.bind(this),
        })

        this._filtersTemplate = {
            price: {
                minPrice: {
                    init: null,
                    selected: null,
                },
                maxPrice: {
                    init: null,
                    selected: null,
                }
            },
            segments: {},
            baggage: {
                withBaggage: {
                    count: 0,
                    selected: false,
                    title: Vocabulary[Util.getCurrentLang()].avia.with_baggage,
                },
                withoutBaggage: {
                    count: 0,
                    selected: false,
                    title: Vocabulary[Util.getCurrentLang()].avia.without_baggage,
                },
            },
            departureTime: {
                minTime: {
                    init: null,
                    seleted: null,
                },
                maxTime: {
                    init: null,
                    selected: null,
                }
            },
            arrivalTime: {
                minTime: {
                    init: null,
                    seleted: null,
                },
                maxTime: {
                    init: null,
                    selected: null,
                }
            },
            durationTime: {
                minTime: {
                    init: null,
                    seleted: null,
                },
                maxTime: {
                    init: null,
                    selected: null,
                }
            },
            departureAirport: {},
            arrivalAirport: {},
            transitAirport: {},
            suppliers: {},
        };

        this._filters = {};

        this.init();
    }

    init(cityFrom, cityTo) {
        this._parseFilters();

        this.$filtersSidebar.find('.avia_fiters_block[data-filter="price"]').addClass('_show');
        this.$filtersSidebar.find('.avia_fiters_block[data-filter="baggage"]').addClass('_show');
        this.$filtersSidebar.find('.avia_fiters_block[data-filter="segments"]').addClass('_show');
        this.$filtersSidebar.find('.avia_fiters_block[data-filter="flight_duration"]').addClass('_show');
        this.$filtersSidebar.find('.avia_fiters_block[data-filter="layover_time"]').addClass('_show');
        this.$filtersSidebar.find('.avia_fiters_block[data-filter="airport"]').addClass('_show');
        this.$filtersSidebar.find('.avia_fiters_block[data-filter="airlines"]').addClass('_show');

        this._deleteSliders();
        this._renderFilters();

        this._insertCitiesIntoFilter(cityFrom, cityTo);
    }

    _parseFilters() {
        const routes = this._getRoutes();
        this._filters = JSON.parse(JSON.stringify(this._filtersTemplate));

        this._numberOfFlights = routes.length;

        const departureDates = [];
        const arrivalDates = [];
        const durationsInHours = [];

        routes.forEach(route => {
            if (!this._filters.price.minPrice.init || route.price < this._filters.price.minPrice.init) { //Минимальная цена
                this._filters.price.minPrice.init = route.price;
            }

            if (!this._filters.price.maxPrice.init || route.price > this._filters.price.maxPrice.init) { //Максимальная цена
                this._filters.price.maxPrice.init = route.price;
            }

            if (route.routes[0].segments) { //Багаж
                if (!route.routes[0].departureSegment.baggage || ['0PC', '0P', '0N', '0K', 'NO', 'N/A', 'NIL'].includes(route.routes[0].departureSegment.baggage)) {
                    this._filters.baggage.withoutBaggage.count = this._filters.baggage.withoutBaggage.count + 1;
                } else {
                    this._filters.baggage.withBaggage.count = this._filters.baggage.withBaggage.count + 1;
                }
            }

            if (route.routes[0].segments) { //Количество пересадок
                const count = route.routes[0].segments.length - 1;
                if (!this._filters.segments.hasOwnProperty(count))
                    this._filters.segments[count] =
                    {
                        count: 1,
                        selected: false,
                        title: count === 0
                            ? Vocabulary[Util.getCurrentLang()].avia.direct_flight
                            : `${count} ${DeclensionNouns(count, Vocabulary[Util.getCurrentLang()].avia.transfers.split('|'))}`,
                    };
                else
                    this._filters.segments[count].count = this._filters.segments[count].count + 1;
            }

            if (route.routes[0].departureSegment) { //Время отправления
                departureDates.push(this._parseDateFromString(route.routes[0].departureSegment.departure_date));
            }

            if (route.routes[0].arrivalSegment) { //Время прибытия
                arrivalDates.push(this._parseDateFromString(route.routes[0].arrivalSegment.arrival_date));
            }

            if (route.routes[0].segments) {  //Время пересадки

            }

            if (route.routes[0].travel) { //Время в пути
                durationsInHours.push(route.routes[0].travel.duration * 60 * 1000);
            }

            if (route.routes[0].departureSegment) { //Аэропорты отправления
                if (!this._filters.departureAirport.hasOwnProperty(route.routes[0].departureSegment.departure_airport)) this._filters.departureAirport[route.routes[0].departureSegment.departure_airport] = { count: 1, selected: false, title: `${route.routes[0].departureSegment.departure_airport_name} (${route.routes[0].departureSegment.departure_city_name})` };
                else this._filters.departureAirport[route.routes[0].departureSegment.departure_airport].count = this._filters.departureAirport[route.routes[0].departureSegment.departure_airport].count + 1;
            }

            if (route.routes[0].arrivalSegment) { //Аэропорты прибытия
                if (!this._filters.arrivalAirport.hasOwnProperty(route.routes[0].arrivalSegment.arrival_airport)) this._filters.arrivalAirport[route.routes[0].arrivalSegment.arrival_airport] = { count: 1, selected: false, title: `${route.routes[0].arrivalSegment.arrival_airport_name} (${route.routes[0].arrivalSegment.arrival_city_name})` };
                else this._filters.arrivalAirport[route.routes[0].arrivalSegment.arrival_airport].count = this._filters.arrivalAirport[route.routes[0].arrivalSegment.arrival_airport].count + 1;
            }

            if (route.routes[0].segments.length > 1) { //Аэропорты пересадки
                route.routes[0].segments.forEach(segment => {
                    if (segment === route.routes[0].arrivalSegment) return;

                    if (!this._filters.transitAirport.hasOwnProperty(segment.arrival_airport)) this._filters.transitAirport[segment.arrival_airport] = { count: 1, selected: false, title: `${segment.arrival_airport_name} (${segment.arrival_city_name})` };
                    else this._filters.transitAirport[segment.arrival_airport].count = this._filters.transitAirport[segment.arrival_airport].count + 1;
                });
            }

            if (route.routes[0].departureSegment) { //Авиакомпании
                if (!this._filters.suppliers.hasOwnProperty(route.routes[0].departureSegment.supplier_iata)) this._filters.suppliers[route.routes[0].departureSegment.supplier_iata] = { count: 1, selected: false, title: route.routes[0].departureSegment.supplier };
                else this._filters.suppliers[route.routes[0].departureSegment.supplier_iata].count = this._filters.suppliers[route.routes[0].departureSegment.supplier_iata].count + 1;
            }
        });

        this._filters.departureTime.minTime.init = departureDates.length > 0 ? new Date(Math.min(...departureDates)) : null;
        this._filters.departureTime.maxTime.init = departureDates.length > 0 ? new Date(Math.max(...departureDates)) : null;

        this._filters.arrivalTime.minTime.init = arrivalDates.length > 0 ? new Date(Math.min(...arrivalDates)) : null;
        this._filters.arrivalTime.maxTime.init = arrivalDates.length > 0 ? new Date(Math.max(...arrivalDates)) : null;

        this._filters.durationTime.minTime.init = durationsInHours.length > 0 ? Math.min(...durationsInHours) : null;
        this._filters.durationTime.maxTime.init = durationsInHours.length > 0 ? Math.max(...durationsInHours) : null;
    }

    _deleteSliders() {
        this._deletePriceSlider();
        this._deleteDepartureTimeSlider();
        this._deleteArrivalTimeSlider();
        this._deleteTravelTimeSlider();
    }

    _renderFilters(cityFrom, cityTo) {
        for (const key in this._filters) {
            if (['price', 'departureTime', 'arrivalTime', 'durationTime'].includes(key)) continue;

            const renderBlock = this.$filtersSidebar.find(`.avia_fiters_block[data-filter="${key}"]`);

            let filters = '';

            for (let filter_name in this._filters[key]) {
                filters += `
                    <div class="_input_checkbox">
                        <input type='checkbox' name='${key}' value='${filter_name}' id='${filter_name}' class='${filter_name}'>
                        <label for='${filter_name}'>
                            <span>${this._filters[key][filter_name].title}</span>
                        </label>
                    </div>
                `;
            }

            if (['departureAirport', 'arrivalAirport', 'transitAirport'].includes(key)) {
                $(`.filters_list_title[data-filter="${key}"]`).nextAll('._input_checkbox').remove();
                $(`.filters_list_title[data-filter="${key}"]`).after(filters);
            } else {
                renderBlock.find('.filters_list').html(filters);
            }
        }

        //Слайдер цены
        this._renderPriceSlider();

        //Слайдер времени отправления
        this._renderDepartureTimeSlider();

        //Слайдер времени прибытия
        this._renderArrivalTimeSlider();

        //Слайдер времени в пути
        this._renderTravelTimeSlider();
    }

    _renderPriceSlider() {
        if (this._filters.price.minPrice.init && this._filters.price.maxPrice.init) {

            noUiSlider.create(this.$priceSlider, {
                start: [this._filters.price.minPrice.init, this._filters.price.maxPrice.init],
                connect: true,
                range: {
                    'min': this._filters.price.minPrice.init,
                    'max': this._filters.price.maxPrice.init
                }
            });

            $(this.$priceSlider).next('.arm_slider_val').text(`${Util.priceFormat(this._filters.price.minPrice.init)} грн - ${Util.priceFormat(this._filters.price.maxPrice.init)} грн`);

            this.$priceSlider.noUiSlider.on('slide', (values, handle, noformat) => {
                this._filters.price.minPrice.selected = parseInt(values[0]);
                this._filters.price.maxPrice.selected = parseInt(values[1]);
                $(this.$priceSlider).next('.arm_slider_val').text(`${Util.priceFormat(parseInt(values[0]))} грн - ${Util.priceFormat(parseInt(values[1]))} грн`);
            });


        }
    }

    _resetPriceSlider() {
        this._filters.price.minPrice.selected = null;
        this._filters.price.maxPrice.selected = null;

        this.$priceSlider.noUiSlider.updateOptions({
            start: [this._filters.price.minPrice.init, this._filters.price.maxPrice.init],
        });

        $(this.$priceSlider).next('.arm_slider_val').text(`${Util.priceFormat(this._filters.price.minPrice.init)} грн - ${Util.priceFormat(this._filters.price.maxPrice.init)} грн`);
    }

    _deletePriceSlider() {
        if (!this.$priceSlider || !this.$priceSlider.noUiSlider) return false;
        this.$priceSlider.noUiSlider.destroy();

        return true;
    }

    _renderDepartureTimeSlider() {
        if (this._filters.departureTime.minTime.init && this._filters.departureTime.maxTime.init) {
            noUiSlider.create(this.$departureTimeSlider, {
                start: [
                    this._filters.departureTime.minTime.init.getTime(),
                    this._filters.departureTime.maxTime.init.getTime()
                ],
                connect: true,
                range: {
                    'min': this._filters.departureTime.minTime.init.getTime(),
                    'max': this._filters.departureTime.maxTime.init.getTime(),
                },
                step: 60 * 1000,
            });

            $(this.$departureTimeSlider).next('.arm_slider_val').text(`${moment(this._filters.departureTime.minTime.init).format('DD.MM.YYYY HH:mm')} - ${moment(this._filters.departureTime.maxTime.init).format('HH:mm')}`);

            this.$departureTimeSlider.noUiSlider.on('slide', (values, handle, noformat) => {
                this._filters.departureTime.minTime.selected = parseInt(values[0]);
                this._filters.departureTime.maxTime.selected = parseInt(values[1]);

                $(this.$departureTimeSlider).next('.arm_slider_val').text(
                    moment(parseInt(values[0])).format('DD.MM.YYYY HH:mm') + " - " + moment(parseInt(values[1])).format('HH:mm'));
            });

        }
    }

    _resetDepartureTimeSlider() {
        this._filters.departureTime.minTime.selected = null;
        this._filters.departureTime.maxTime.selected = null;

        this.$departureTimeSlider.noUiSlider.updateOptions({
            start: [
                this._filters.departureTime.minTime.init.getTime(),
                this._filters.departureTime.maxTime.init.getTime(),
            ],
        });

        $(this.$departureTimeSlider).next('.arm_slider_val').text(`${moment(this._filters.departureTime.minTime.init).format('DD.MM.YYYY HH:mm')} - ${moment(this._filters.departureTime.maxTime.init).format('HH:mm')}`);
    }

    _deleteDepartureTimeSlider() {
        if (!this.$departureTimeSlider || !this.$departureTimeSlider.noUiSlider) return false;
        this.$departureTimeSlider.noUiSlider.destroy();

        return true;
    }

    _renderArrivalTimeSlider() {
        if ($("#slider-time-2").length && this._filters.arrivalTime.minTime.init && this._filters.arrivalTime.maxTime.init) {
            noUiSlider.create(this.$arrivalTimeSlider, {
                start: [
                    this._filters.arrivalTime.minTime.init.getTime(),
                    this._filters.arrivalTime.maxTime.init.getTime()
                ],
                connect: true,
                range: {
                    'min': this._filters.arrivalTime.minTime.init.getTime(),
                    'max': this._filters.arrivalTime.maxTime.init.getTime(),
                },
                step: 60 * 60 * 1000,
            });

            $(this.$arrivalTimeSlider).next('.arm_slider_val').text(`${moment(this._filters.arrivalTime.minTime.init).format('DD.MM.YYYY HH:mm')} - ${moment(this._filters.arrivalTime.maxTime.init).format('DD.MM.YYYY HH:mm')}`);

            this.$arrivalTimeSlider.noUiSlider.on('slide', (values, handle, noformat) => {
                this._filters.arrivalTime.minTime.selected = parseInt(values[0]);
                this._filters.arrivalTime.maxTime.selected = parseInt(values[1]);

                $(this.$arrivalTimeSlider).next('.arm_slider_val').text(
                    moment(parseInt(values[0])).format('DD.MM.YYYY HH:mm') + " - " + moment(parseInt(values[1])).format('DD.MM.YYYY HH:mm'));
            });
        }
    }

    _resetArrivalTimeSlider() {
        this._filters.arrivalTime.minTime.selected = null;
        this._filters.arrivalTime.maxTime.selected = null;

        this.$arrivalTimeSlider.noUiSlider.updateOptions({
            start: [
                this._filters.arrivalTime.minTime.init.getTime(),
                this._filters.arrivalTime.maxTime.init.getTime(),
            ],
        });

        $(this.$arrivalTimeSlider).next('.arm_slider_val').text(`${moment(this._filters.arrivalTime.minTime.init).format('DD.MM.YYYY HH:mm')} - ${moment(this._filters.arrivalTime.maxTime.init).format('DD.MM.YYYY HH:mm')}`);
    }

    _deleteArrivalTimeSlider() {
        if (!this.$arrivalTimeSlider || !this.$arrivalTimeSlider.noUiSlider) return false;
        this.$arrivalTimeSlider.noUiSlider.destroy();

        return true;
    }

    _renderTravelTimeSlider() {
        if (this._filters.durationTime.minTime.init && this._filters.durationTime.maxTime.init) {
            noUiSlider.create(this.$travelTimeSlider, {
                start: [this._filters.durationTime.maxTime.init],
                range: {
                    'min': [this._filters.durationTime.minTime.init],
                    'max': [this._filters.durationTime.maxTime.init]
                },
                step: 6000,
            });

            $(this.$travelTimeSlider).next('.arm_slider_val').text(this._formatTimeFromMinutes(this._filters.durationTime.maxTime.init));
            $("#slider-time-3").append('<div class="_line" style="width: 100%;"></div>');


            this.$travelTimeSlider.noUiSlider.on('slide', (value, handle, noformat) => {
                this._filters.durationTime.maxTime.selected = value;
                let date_1 = moment().valueOf(),
                    date_2 = moment(moment().valueOf() + parseInt(value)),
                    date_diff = date_2.diff(date_1, 'minutes'),
                    current_hours = Math.floor(date_diff / 60),
                    current_minutes = (date_diff - current_hours * 60).toFixed(0);

                $(this.$travelTimeSlider).next('.arm_slider_val').text((current_hours < 10 ? '0' + current_hours : current_hours) + ':' + (current_minutes < 10 ? '0' + current_minutes : current_minutes));

                const transformCss = $("#slider-time-3 .noUi-origin").attr('style');
                const regex = /translate\(([-+]?\d*\.?\d+)%/;
                const match = 100 - Math.abs(transformCss.match(regex)[1]);

                if (!$("#slider-time-3 ._line").length) {
                    $("#slider-time-3").append('<div class="_line"></div>');
                }
                $("#slider-time-3 ._line").css('width', match + '%');
            });

        }
    }

    _resetTravelTimeSlider() {
        this._filters.durationTime.minTime.selected = null;
        this._filters.durationTime.maxTime.selected = null;

        this.$travelTimeSlider.noUiSlider.updateOptions({
            start: [this._filters.durationTime.minTime.init],
        });

        $(this.$travelTimeSlider).next('.arm_slider_val').text(this._formatTimeFromMinutes(this._filters.durationTime.minTime.init));
    }

    _deleteTravelTimeSlider() {
        if (!this.$travelTimeSlider || !this.$travelTimeSlider.noUiSlider) return false;
        this.$travelTimeSlider.noUiSlider.destroy();

        return true;
    }

    _formatTimeFromMinutes(milliseconds) {
        let totalMinutes = Math.floor(milliseconds / (1000 * 60)); // Общее количество минут
        let minutes = totalMinutes % 60; // Остаток минут после вычета часов
        let hours = Math.floor(totalMinutes / 60); // Общее количество часов

        // Форматируем часы и минуты в строку "часы:минуты"
        let formattedHours = hours.toString().padStart(2, '0'); // Добавляем ведущий ноль, если часов менее 10
        let formattedMinutes = minutes.toString().padStart(2, '0'); // Добавляем ведущий ноль, если минут менее 10

        // Возвращаем форматированную строку времени
        return `${formattedHours}:${formattedMinutes}`;
    }
    //Фильтровать по кнопке
    _filter() {
        const selectedCheckox = this.$filtersSidebar.find('input[type="checkbox"]:checked');
        // if (selectedCheckox.length === 0) return $(this.$page).find('.avia_results_item').show();
        this._resetFilterValues(this._filters);

        //Получаем данные по выбранным фильтрам и сохраняем
        selectedCheckox.each((index, filter) => {
            const type = $(filter).attr('name');
            this._filters[type][$(filter).val()].selected = true;
        });

        //Этот блок нужен чтобы проверить есть ли вообще выбранный фильтр
        const hasSelectedSegment = Object.values(this._filters.segments).some(segment => segment.selected);
        const hasSelectedDepartureAirport = Object.values(this._filters.departureAirport).some(airport => airport.selected);
        const hasSelectedArrivalAirport = Object.values(this._filters.arrivalAirport).some(airport => airport.selected);
        const hasSelectedTransitAirport = Object.values(this._filters.transitAirport).some(airport => airport.selected);
        const hasSelectedSuppliers = Object.values(this._filters.suppliers).some(supplier => supplier.selected);

        const routes = this._getRoutes();
        routes.forEach(route => {
            const routeElement = $(this.$page).find(`.avia_results_item[data-routeid="${route.id}"]`);

            let showRoute = true;

            //Фильтр по цене минимальной
            if (this._filters.price.minPrice.selected && route.price < this._filters.price.minPrice.selected) {
                showRoute = false;
            }

            //Фильтр по цене максимальной
            if (this._filters.price.maxPrice.selected && route.price > this._filters.price.maxPrice.selected) {
                showRoute = false;
            }

            //Фильтр по минимальной дате отправления
            if (this._filters.departureTime.minTime.selected && this._parseDateFromString(route.routes[0].departureSegment.departure_date).getTime() < this._filters.departureTime.minTime.selected) {
                showRoute = false;
            }

            //Фильтр по максимальной дате отправления
            if (this._filters.departureTime.maxTime.selected && this._parseDateFromString(route.routes[0].departureSegment.departure_date).getTime() > this._filters.departureTime.maxTime.selected) {
                showRoute = false;
            }

            //Фильтр по минимальной дате прибытия
            if (this._filters.arrivalTime.minTime.selected && this._parseDateFromString(route.routes[0].arrivalSegment.arrival_date).getTime() < this._filters.arrivalTime.minTime.selected) {
                showRoute = false;
            }

            //Фильтр по максимальной дате прибытия
            if (this._filters.arrivalTime.maxTime.selected && this._parseDateFromString(route.routes[0].arrivalSegment.arrival_date).getTime() > this._filters.arrivalTime.maxTime.selected) {
                showRoute = false;
            }

            //Фильтр по времение в пути
            if (this._filters.durationTime.maxTime.selected && route.routes[0].travel.duration * 60 * 1000 > this._filters.durationTime.maxTime.selected) {
                showRoute = false;
            }

            //Есть багаж
            if (this._filters.baggage.withBaggage.selected && !this._filters.baggage.withoutBaggage.selected) {
                // Показываем только рейсы с багажом
                if (['0PC', '0P', '0N', '0K', 'NO', 'N/A', 'NIL', ''].includes(route.routes[0].departureSegment.baggage)) {
                    showRoute = false;
                }
            }

            //Нету багажа
            if (this._filters.baggage.withoutBaggage.selected && !this._filters.baggage.withBaggage.selected) {
                // Показываем только рейсы без багажа
                if (!['0PC', '0P', '0N', '0K', 'NO', 'N/A', 'NIL', ''].includes(route.routes[0].departureSegment.baggage)) {
                    showRoute = false;
                }
            }

            //Количество пересадок
            const segmentsLength = route.routes[0].segments.length - 1;
            if (hasSelectedSegment && !this._filters.segments[segmentsLength].selected) {
                showRoute = false;
            }

            //Аэропорт вылета
            if (
                hasSelectedDepartureAirport
                && !this._filters.departureAirport[route.routes[0].departureSegment.departure_airport].selected
            ) {
                showRoute = false;
            }

            //Аэропорт прилета
            if (
                hasSelectedArrivalAirport
                && !this._filters.arrivalAirport[route.routes[0].arrivalSegment.arrival_airport].selected
            ) {
                showRoute = false;
            }

            //Аэропорт пересадки
            if (hasSelectedTransitAirport && route.routes[0].segments.length === 1) {
                showRoute = false;
            } else if (hasSelectedTransitAirport) {
                let transitAirportSelected = false;
                route.routes[0].segments.forEach(segment => {
                    if (segment !== route.routes[0].arrivalSegment) {
                        if (this._filters.transitAirport[segment.arrival_airport].selected) {
                            transitAirportSelected = true;
                        }
                    }
                });

                if (!transitAirportSelected) {
                    showRoute = false;
                }
            }

            //Авиакомпания
            if (hasSelectedSuppliers && !this._filters.suppliers[route.routes[0].departureSegment.supplier_iata].selected) {
                showRoute = false;
            }


            if (showRoute) {
                routeElement.show();
            } else {
                routeElement.hide();
            }
        });

        this._numberOfFlights = $(this.$page.find('.avia_results_item:not([style*="display: none"])')).length;

        $(this.$page).find('.flights_count').html(`<span class="number_flights">${this._numberOfFlights}</span> ${DeclensionNouns(this._numberOfFlights, Vocabulary[Util.getCurrentLang()].routes_count.split('|'))} ${Vocabulary[Util.getCurrentLang()].found}`);
    }

    _resetFilterValues(filters) {
        for (let key in filters) {
            if (['price', 'departureTime', 'arrivalTime', 'durationTime'].includes(key)) {
                continue;
            }

            if (!filters[key].hasOwnProperty('selected')) {
                this._resetFilterValues(filters[key])
            } else {
                filters[key].selected = false;
            }
        }

        return filters;
    }

    _resetFilters() {
        this._resetFilterValues(this._filters);
        $(this.$page).find('.avia_results_item').show();
        $(this.$filtersSidebar).find('input[type="checkbox"]').prop('checked', false);

        this._resetPriceSlider();
        this._resetDepartureTimeSlider();
        this._resetArrivalTimeSlider();
    }

    _parseDateFromString(dateString) {
        let [departureDay, departureMonth, departureYear, deparureHours, departureMinutes] = dateString.split(/[.: ]/);
        departureMonth = parseInt(departureMonth) - 1;

        return new Date(departureYear, departureMonth, departureDay, deparureHours, departureMinutes)
    }

    hide() {
        this.$filtersSidebar.find('.avia_fiters_block').removeClass('_show');
        $(this.$filtersSidebar).hide();
    }

    show() {
        $(this.$filtersSidebar).show();
    }

    _insertCitiesIntoFilter(cityFrom, cityTo) {
        this.$filtersSidebar.find('span._from_to').text(`${cityFrom} - ${cityTo}`);
        this.$filtersSidebar.find('span._from').text(cityFrom);
        this.$filtersSidebar.find('span._to').text(cityTo);
    }
}
